import { StyleSheet, type ViewStyle } from 'react-native';

export const focusTryOnStyles = StyleSheet.create({
  root: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  layer: {
    ...StyleSheet.absoluteFillObject,
    width: '100%',
    height: '100%',
  },
  layerDimmed: {
    opacity: 0.96,
  },
});

/** Absolute crop box positioned in pixels (offsets may be negative). */
export function getCropBoxStyle(box: {
  width: number;
  height: number;
  left: number;
  top: number;
}): ViewStyle {
  return {
    position: 'absolute',
    width: box.width,
    height: box.height,
    left: box.left,
    top: box.top,
  };
}
